import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Spinner } from "reactstrap";

// availity-reactstrap-validation

// action
import { registerUser, apiError } from "../../store/actions";

//Import Icons
import FeatherIcon from "feather-icons-react";
//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";

import AuthLayout from "../../components/authenticate/AuthLayout";
import TokenError from "../../components/authenticate/TokenError";
import CreateNewPassForm from "../../components/authenticate/CreateNewPassForm";

const CheckForgotPassToken = (props) => {
    const dispatch = useDispatch();

    const { user, registrationError } = useSelector((state) => ({
        user: state.Account.user,
        registrationError: state.Account.registrationError,
        loading: state.Account.loading,
    }));

    // handleValidSubmit
    const handleValidSubmit = (values) => {
        dispatch(registerUser(values));
    };

    useEffect(() => {
        setStatus();
    }, []);

    const [tokenError , setTokenError] = useState(false)
    const [createNewPassword , setcreateNewPassword] = useState(false)

    //   const taskName = "DNSRecords";
    const token = window.location.href.split("account-password-reset/")[1];
    // console.log(token);
    async function setStatus(event) {
        // e.preventDefault()
        const response = await fetch(`${process.env.REACT_APP_DEFAULTPATH}check-forgot-password-token`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                token,
            }),
        });
        const data = await response.json();
        // console.log("data", data)
        if (data.status) {
            setcreateNewPassword(true)
            // localStorage.setItem("passToken", true);
            localStorage.setItem("userID", data.userID);
            // window.location.href = "/create-new-password";
        }
        else {
            // localStorage.setItem("passToken", false);
            setTokenError(true)
            // window.location.href = "/create-new-password";
        }
        // window.location.href = "/account-verify-message";
        // if (data.status === "ok") {
        //   console.log("password change success");
        //   window.location.href = "/Login";
        // }
        // console.log(data.data);
        // window.location.href = "/Login";
    }


    return (


        <React.Fragment>
            <MetaTags>
                <title>Register | Glogix </title>
            </MetaTags>


            <AuthLayout>
                <div className="gx-auth-card">
                    {(()=>{
                        if(tokenError){
                            return(
                                <TokenError heading="Token Expired" para="Please resend an email to continue with your account"/>
                            )
                        }
                        if(createNewPassword){
                            return(
                                <CreateNewPassForm/>
                            )
                        }
                        return (
                            <div className="gx-auth-title mb-0">
                                <Spinner className="mb-3" color="primary" />
                                <p>Verifying your reset link...</p>
                            </div>
                        )
                    })()}
                </div>
            </AuthLayout>
        </React.Fragment>
    );
};

export default CheckForgotPassToken;
